import React, { Component, Fragment } from 'react';
import { translate } from '../Services/translation';

class WishList extends Component {
    constructor(props) {
        super(props);
        this.state = { items: window.__litium.preloadState.wishlist.items };
    }

    handleRemove(articleNumber, quantity) {
        this.setState({ items: window.__litium.preloadState.wishlist.items.filter(x => x.articleNumber != articleNumber) })
        this.props.onRemove(articleNumber, quantity)
    }

    render() {
        return (
            <>
                {this.state.items.length > 0 ?
                    <>
                        <div className="row">
                            <div className="product-list">
                                <ul className="product-list product-list__row">
                                    {this.state.items.map((item) =>
                                        <li key={item.articleNumber} className="product-list__item columns small-12 large-3">
                                            <div className="product__wrapper">
                                                <div className="wishlist-favourite-button" onClick={() => this.handleRemove(item.articleNumber, -1)}>
                                                    <i className="fas fa-bookmark"></i>
                                                </div>
                                                <div className="product__figure show-for-large">
                                                    <a href={item.url} className="product__image-link">
                                                        <img src={item.image} className="product__image" />
                                                    </a>
                                                </div>
                                                <div className="product__info">
                                                    <div className="product__info-container">
                                                        <div className="product__figure hide-for-large">
                                                            <a href={item.url} className="product__image-link">
                                                                <img src={item.image} className="product__image" />
                                                            </a>
                                                        </div>
                                                        <div className="product__info-wrapper">
                                                            <a href={item.url} title={item.name}>
                                                                <h6 className="product__name">{item.name}</h6>
                                                                <div className="product__brand">{item.brand}</div>
                                                            </a>
                                                            <div className="product__price">
                                                                <div className="product__price">
                                                                    {item.isTieredPrice && <h2>{translate("product.pricefrom")}:</h2>}
                                                                    {item.formattedPrice} <span className="product__excluding-vat">{translate("alternativevariant.excluding")}</span>
                                                                </div>
                                                            </div>
                                                            {item.quantity > 1 &&
                                                                <div className="product__variant-info">
                                                                    <i className="fal fa-layer-group"></i>
                                                                    {translate("product.numvariants")} {item.quantity} {translate("product.colors").toLowerCase()}
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <buy-button data-css-className="button buy-button product__buy-button" data-href={item.url} data-label={translate("product.show")}><span><a className="button buy-button product__buy-button" href={item.url}>{translate("product.show")}</a></span>
                                                    </buy-button>
                                                </div>
                                            </div>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </>
                    :
                    ""
                }
            </>
        )
    }
}


export default WishList;